import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { KrzzLogo } from "./KrzzLogo";

export const Footer = () => {
  return (
    <footer className="bg-[#0b0b0b] border-t border-[#2a2a2a] text-white">
      <div className="container-auto py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-2">
            <KrzzLogo className="mb-6 h-16 w-auto" size="large" />
            <p className="text-gray-400 leading-relaxed max-w-md mb-6">
              Import și vânzare autoturisme second-hand din surse verificate.
              Oferim seriozitate, transparență și suport complet în procesul de achiziție.
            </p>
            <div className="flex gap-3">
              <a
                href="https://wa.me/40746184905"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 bg-[#25D366] rounded-lg flex items-center justify-center hover:bg-[#20bd5a] transition-colors"
                aria-label="WhatsApp"
              >
                <svg className="w-6 h-6 fill-white" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" /></svg>
              </a>
              <a
                href="tel:0746184905"
                className="w-12 h-12 bg-[#1a1a1a] border border-[#2a2a2a] rounded-lg flex items-center justify-center hover:bg-[#2a2a2a] transition-colors"
                aria-label="Telefon"
              >
                <Phone className="w-5 h-5" />
              </a>
              <a
                href="mailto:repede_razvan@yahoo.com"
                className="w-12 h-12 bg-[#1a1a1a] border border-[#2a2a2a] rounded-lg flex items-center justify-center hover:bg-[#2a2a2a] transition-colors"
                aria-label="Email"
              >
                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-semibold text-sm uppercase tracking-wider mb-6 text-white">Navigare</h4>
            <div className="flex flex-col gap-3">
              <a href="" className="text-gray-400 hover:text-white text-sm transition-colors">Acasă</a>
              <a href="#masini" className="text-gray-400 hover:text-white text-sm transition-colors">Mașini în stoc</a>
              <a href="#contact" className="text-gray-400 hover:text-white text-sm transition-colors">Contact</a>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-sm uppercase tracking-wider mb-6 text-white">Contact</h4>
            <div className="flex flex-col gap-4">
              <a href="tel:0746184905" className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors">
                <div className="w-10 h-10 bg-[#1a1a1a] border border-[#2a2a2a] rounded-lg flex items-center justify-center flex-shrink-0">
                  <Phone className="w-4 h-4" />
                </div>
                <span className="text-sm">0746 184 905</span>
              </a>
              <a href="mailto:repede_razvan@yahoo.com" className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors">
                <div className="w-10 h-10 bg-[#1a1a1a] border border-[#2a2a2a] rounded-lg flex items-center justify-center flex-shrink-0">
                  <Mail className="w-4 h-4" />
                </div>
                <span className="break-all text-sm">repede_razvan@yahoo.com</span>
              </a>
              <div className="flex items-start gap-3 text-gray-400">
                <div className="w-10 h-10 bg-[#1a1a1a] border border-[#2a2a2a] rounded-lg flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-4 h-4" />
                </div>
                <span className="text-sm">Strada Armatei nr. 5B, Fălticeni, România</span>
              </div>
            </div>
          </div>
        </div>

        {/* ANPC / SAL badges */}
        <div className="mt-10 flex flex-wrap items-center gap-3">
          <a
            href="https://reclamatiisal.anpc.ro/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex"
          >
            <img
              src="/images/anpc.webp"
              alt="ANPC"
              className="h-10 w-auto rounded-md bg-white/5 backdrop-blur px-2 py-1 opacity-80 hover:opacity-100 transition"
            />
          </a>

          <a
            href="https://consumer-redress.ec.europa.eu/site-relocation_en"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex"
          >
            <img
              src="/images/sal.webp"
              alt="Soluționarea alternativă a litigiilor"
              className="h-10 w-auto rounded-md bg-white/5 backdrop-blur px-2 py-1 opacity-80 hover:opacity-100 transition"
            />
          </a>
        </div>

        <div className="mt-16 pt-8 border-t border-[#2a2a2a]">
          {/* Company Details */}
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mb-4">
            <div className="text-gray-500 text-sm text-center sm:text-left">
              <p className="font-medium text-gray-400">SC KRZZ SRL</p>
              <p>CUI: RO 43968630 | J33/582/2021</p>
            </div>
            <p className="text-gray-500 text-sm">
              Fălticeni, România
            </p>
          </div>

          {/* Legal Links */}
          <div className="flex flex-wrap justify-center gap-4 py-4 border-t border-[#2a2a2a]/50">
            <Link
              to="/politica-confidentialitate"
              className="text-gray-500 hover:text-white text-sm transition-colors"
            >
              Politica de confidențialitate
            </Link>
            <span className="text-gray-700">•</span>
            <Link
              to="/termeni-conditii"
              className="text-gray-500 hover:text-white text-sm transition-colors"
            >
              Termeni și condiții
            </Link>
            <span className="text-gray-700">•</span>
            <Link
              to="/politica-cookies"
              className="text-gray-500 hover:text-white text-sm transition-colors"
            >
              Politica cookies
            </Link>
          </div>
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 pt-4 border-t border-[#2a2a2a]/50">

            {/* Stânga */}
            <p className="text-gray-500 text-sm">
              © {new Date().getFullYear()} KRZZ Auto. Toate drepturile rezervate.
            </p>

            {/* Dreapta */}
            <p className="text-gray-500 text-sm">
              Realizat de{" "}
              <a
                href="https://wa.me/40754482899"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white transition"
              >
                Alexandru
              </a>
            </p>

          </div>
        </div>
      </div>
    </footer>
  );
};
